import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { AccountRoutingModule } from './account-routing.module';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PasswordRecoveryComponent } from './password-recovery/password-recovery.component';
import { ResetEmailComponent } from './reset-email/reset-email.component';
import { Verify2FAComponent } from './verify-2fa/verify-2fa.component';
import { ComponentsModule } from '../components/components.module';
import { LanguageSwitcherComponent } from './components/language-switcher/language-switcher.component';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    ResetPasswordComponent,
    PasswordRecoveryComponent,
    ResetEmailComponent,
    Verify2FAComponent,
    LanguageSwitcherComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    AccountRoutingModule,
    ComponentsModule,
    NgbDropdownModule,
    NgbTooltipModule,
  ],
})
export class AccountModule {}
